import { createApi } from '@reduxjs/toolkit/query/react';
import { createIbkBaseQuery } from '../api/createIbkBaseQuery';
import { config } from '../config';
export const customClientIbkBaseQuery = createIbkBaseQuery(config.apiClientIbkUrl);
export const clientIbkApi = createApi({
    reducerPath: 'clientIbkApi',
    baseQuery: customClientIbkBaseQuery,
    tagTypes: ['EmissorContract'],
    endpoints: () => ({}),
});
